import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateUser } from '../services/users';
import { userKeys } from './useUsersQuery';
import type { UpdateUserFormInputs } from '../schemas/user.schema';
import type { AdminUser } from '../types/users.types';

interface UpdateUserParams {
    id: string;
    payload: UpdateUserFormInputs;
}

export const useUpdateUserMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<AdminUser, Error, UpdateUserParams>({
        mutationFn: ({ id, payload }) => updateUser(id, payload),
        onSuccess: (_, { id }) => {
            queryClient.invalidateQueries({ queryKey: userKeys.detail(id) });
            queryClient.invalidateQueries({ queryKey: userKeys.lists() });
        },
    });
};
